<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['images']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              required: true,
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Header({
              text: 'Zdjęcia'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'images'],
              items: this.form.images.map((item, i) => ({
                headerLabel: get(item, ['caption_pl']),
                fields: [
                  new fields.Image({
                    label: 'Zdjęcie',
                    required: true,
                    modelPath: [this, 'form', 'images', i, 'image']
                  }),
                  new fields.Input({
                    label: 'Podpis',
                    modelPath: [this, 'form', 'images', i, 'caption'],
                    multilingual: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
